import MaterialPropertyAssigner from "../../../output/assets/materials/material-property-assigner.js";

class ThreeMaterialVector2Assigner extends MaterialPropertyAssigner {
    constructor(defaultValues) {
        super();

        this._defaultValues = defaultValues;
    }

    setProperty(material, property, value) {
        if (value === undefined) {
            value = this._defaultValues[property];
        }

        if (typeof value === "object" && value !== null) {
            material[property].set(value.x, value.y);
        } else {
            material[property].set(value, value);
        }
    }
}

export default ThreeMaterialVector2Assigner;
